import React from 'react';
import { WfnRadioButton } from '@adp-wfn/mdf-wc-react';

export interface IMDFRadioProps {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
  radioGroupValue?: any;
  tabIndex?: number;
  value?: any;
  onChange?: (value: any) => void;
}

export const MDFRadio = (props: IMDFRadioProps) => {
  const handleSdfChange = (event: CustomEvent) => {
    props?.onChange?.(event.detail.value);
  };

  return (
    <WfnRadioButton {...props} onSdfChange={handleSdfChange}/>
  );
};

MDFRadio.displayName = 'MDFRadio';
